import React, { memo, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Slider from 'react-slick';
import { getCountdown } from '../../helper/Countdown';
import usePageContent from '../../hooks/usePageContent';
import StoreSellerProductsList from './StoreSellerProductsList';
import useProductCategory from '../../hooks/useProductCategory';
import useProductList from '../../hooks/useProductList';
import { useAppConfig } from '../../context/AppConfigContext';
import { generateThousandSeparator } from '../../utils/string-manipulator';
import { formatCurrency } from '../../constants';
import { Eye } from '@phosphor-icons/react';

const SampleNextArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-right" />
        </button>
    );
});

const SamplePrevArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-left" />
        </button>
    );
});

const SellerStoreProductsHome = ({ storeId, productCategory }) => {
    const [isLastPage, setIsLastPage] = useState(false);
    const [isFirstPage, setIsFirstPage] = useState(true);

    const [sortBy, setSortBy] = useState('name-asc');

    let [grid, setGrid] = useState(false);
    let [active, setActive] = useState(false);

    const { lang } = useParams();
    const [timeLeft, setTimeLeft] = useState(getCountdown());
    const { fetchPageContent, data, status, error, resetStatus } = usePageContent();
    const [dataPromo, setDataPromo] = React.useState([]);

    useEffect(() => {
        if (status === 'idle') {
            fetchPageContent({ type: 'home', field: 'HotDealsToday', language: 'en-US' });
        }

        if (status === 'done') {
            //console.log(data);
            setDataPromo(data === '' ? [] : JSON.parse(data));
        }
        // console.log(data);
        // console.log(status);
    }, [status]);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getCountdown());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    //nav pindah kesini

    const [filterCategoryId, setFilterCategoryId] = useState(undefined);
    const [page, setPage] = useState(0);
    const [field, direction] = sortBy.includes('-') ? sortBy.split('-') : [sortBy, undefined];

    // const {
    //     fetchProductCategory,
    //     fetchProductCategoryByUser,
    //     fetchProductCategoryByShop,
    //     data: productCategory,
    //     status: productCategoryStatus,
    //     error: productCategoryError,
    // } = useProductCategory();

    const {
        fetchProductList,
        data: productList,
        total: productListTotal,
        status: productListStatus,
        error: productListError
    } = useProductList();

    // useEffect(() => {
    //     // fetchProductCategory();
    //     fetchProductCategoryByShop(storeId.storeId);

    // }, [storeId.storeId]);

    //console.log(productCategory)

    const setSelectedGallery = (id) => {
        setFilterCategoryId(id);
        setPage(0);
    };

    const setAllCategory = () => {
        setFilterCategoryId(undefined);
        setPage(0);
    };

    useEffect(() => {
        if (!storeId) return;
        // console.log("check fetching categoryid", filterCategoryId);
        fetchProductList({
            companyId: storeId,
            categoryIds: filterCategoryId,
            sortBy: sortBy.split('-')[0],
            sortType: sortBy.split('-')[1],
            // skip: page,
            skip: page * 20,
            take: 20
        });
    }, [filterCategoryId, page, storeId, sortBy]);

    useEffect(() => {
        //console.log(productListStatus);
        if (productListStatus === 'done') {
            setIsLastPage(page + 1 === Math.ceil(productListTotal / 20));
            setIsFirstPage(page === 0);
        }
    }, [productListStatus]);

    let sidebarController = () => {
        setActive(!active);
    };

    // console.log("productList data displayed" , productList)

    //nav function

    return (
        <section className="sellerstore-products py-80">
            <div className="container container-md">
                <div className="row">
                    <div className="col-12 col-lg-2">
                        <div className="categorySide">
                            <div className="side_menu_header d-flex align-items-center text-black gap-10">
                                <i className="ph-bold ph-list-bullets"></i> <span>Category</span>
                            </div>
                            <ul className="side_nav ps-30 mt-10">
                                <li>
                                    <a
                                        className="active"
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setAllCategory();
                                        }}
                                    >
                                        All Products
                                    </a>
                                </li>
                                {Array.isArray(productCategory) &&
                                    productCategory.length > 0 &&
                                    productCategory.slice(0, 5).map((item, index) => (
                                        <li key={`category-${index}`}>
                                            <Link
                                                to={'#'}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setSelectedGallery(item.id);
                                                }}
                                                style={{
                                                    // padding: "0.5rem 1rem",
                                                    color: filterCategoryId != item.id ? '#828282' : '#970a02',
                                                    fontSize: '14px',
                                                    fontWeight: '500'
                                                    // borderBottom: filterCategoryId !== item.id ? "0" : "2px solid #970a02"
                                                }}
                                            >
                                                {item.name}
                                            </Link>
                                        </li>
                                    ))}
                                {/* <li>
                                    <a href='#'>Category 1</a>
                                </li>
                                <li>
                                    <a href='#'>Category 2</a>
                                </li>
                                <li>
                                    <a href='#'>Category 3</a>
                                </li>
                                <li>
                                    <a href='#'>Category 4</a>
                                </li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="col-12 col-lg-10">
                        <div className="section-heading py-10 px-16">
                            <div className="d-flex justify-content-center justify-content-sm-between flex-wrap  flex-md-no-wrap gap-8 h-100">
                                <div className="sortHeader">
                                    <div className="sortitems d-flex justify-content-between flex-wrap flex-sm-no-wrap align-items-center h-100 gap-8">
                                        <span className="text-18 text-black text_quicksand fw-medium">Sort by</span>
                                        <button
                                            className={`btn_custom sort ${sortBy === 'popular-desc' ? 'active' : ''}`}
                                            onClick={() => setSortBy('popular-desc')}
                                        >
                                            Popular
                                        </button>

                                        <button
                                            className={`btn_custom sort ${sortBy === 'newest-desc' ? 'active' : ''}`}
                                            onClick={() => setSortBy('newest-desc')}
                                        >
                                            Newest
                                        </button>
                                        {/* <button className='btn_custom sort active' >Popular</button>
                                        <button className='btn_custom sort' >Newest</button> */}
                                        <button className="btn_custom sort d-none">Best Seller</button>
                                    </div>
                                </div>
                                <div className="paginationHeader">
                                    <div className="d-flex align-items-center gap-10">
                                        <span className="fw-medium text-18 text_quicksand text-black">
                                            {page + 1}/{Math.ceil(productListTotal / 20)}
                                        </span>
                                        <div className="flex-center gap-10">
                                            {/* <button className='pagination_btn page_prev flex-center rounded-circle'>
                                                <i className="ph ph-caret-left" />
                                            </button> */}
                                            {/* {productListTotal > 20 && !isFirstPage && ( */}

                                            <button
                                                disabled={!isFirstPage ? '' : true}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setPage(page - 1);
                                                }}
                                                className="pagination_btn page_prev flex-center rounded-circle"
                                            >
                                                <i className="ph ph-caret-left" />
                                            </button>
                                            {/* )} */}
                                            {/* {productListTotal > 20 && !isLastPage && ( */}

                                            <button
                                                disabled={productListTotal > 20 && !isLastPage ? '' : true}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setPage(page + 1);
                                                }}
                                                className="pagination_btn page_prev flex-center rounded-circle"
                                            >
                                                <i className="ph ph-caret-right" />
                                            </button>
                                            {/* )} */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row g-12">
                            <div className="col-md-12">
                                {/* <StoreSellerProductsList product={productList} /> */}
                                <div className="col-xxl-12 col-lg-12" style={{ position: 'relative' }}>
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '0',
                                            left: '0',
                                            width: '100%',
                                            height: '100%',
                                            backgroundColor: '#fff',
                                            //backgroundColor: "rgba(0, 0, 0, 0.5)",
                                            zIndex: '999',
                                            display: productListStatus === 'loading' ? 'block' : 'none'
                                        }}
                                    >
                                        <img
                                            src="assets/images/icon/preloader.gif"
                                            style={{
                                                position: 'absolute',
                                                top: '0',
                                                left: '50%',
                                                marginTop: '100px',
                                                transform: 'translate(-50%, -50%)'
                                            }}
                                            alt=""
                                        />
                                    </div>
                                    <div className="flex-between gap-16 flex-wrap mb-40 ">
                                        {productListTotal > 0 ? (
                                            <>
                                                <span className="text-gray-900 text-md">
                                                    Showing {page * 20 + 1}-{(page + 1) * 20 < productListTotal ? (page + 1) * 20 : productListTotal} of {productListTotal} result
                                                </span>
                                                <div className="position-relative flex-align gap-16 flex-wrap">
                                                    <div className="list-grid-btns flex-align gap-16">
                                                        <button
                                                            onClick={() => setGrid(true)}
                                                            type="button"
                                                            className={`w-44 h-44 flex-center border rounded-6 text-2xl list-btn border-gray-100 ${
                                                                grid === true && 'border-main-600 text-white bg-main-one-600'
                                                            }`}
                                                        >
                                                            <i className="ph-bold ph-list-dashes" />
                                                        </button>
                                                        <button
                                                            onClick={() => setGrid(false)}
                                                            type="button"
                                                            className={`w-44 h-44 flex-center border rounded-6 text-2xl grid-btn border-gray-100 ${
                                                                grid === false && 'border-main-600 text-white bg-main-one-600'
                                                            }`}
                                                        >
                                                            <i className="ph ph-squares-four" />
                                                        </button>
                                                    </div>
                                                    <div className="position-relative text-gray-500 flex-align gap-4 text-14">
                                                        <label htmlFor="sorting" className="text-inherit flex-shrink-0">
                                                            Sort by:{' '}
                                                        </label>
                                                        <select
                                                            value={sortBy}
                                                            // defaultValue={"name-asc"}
                                                            className="form-control common-input px-14 py-14 text-inherit rounded-6 w-auto"
                                                            id="sorting"
                                                            onChange={(e) => setSortBy(e.target.value)}
                                                        >
                                                            <option value={'name-asc'}>Name A-Z</option>
                                                            <option value={'name-desc'}>Name Z-A</option>
                                                            <option value={'price-asc'}>Lowest Price</option>
                                                            <option value={'price-desc'}>Highest Price</option>
                                                            <option value={'popular-desc'}>Popular</option>
                                                            <option value={'newest'}>Newest</option>
                                                        </select>
                                                    </div>
                                                    <button
                                                        onClick={sidebarController}
                                                        type="button"
                                                        className="w-44 h-44 d-lg-none d-flex flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
                                                    >
                                                        <i className="ph-bold ph-funnel" />
                                                    </button>
                                                </div>
                                            </>
                                        ) : (
                                            <span className="text-gray-900">No Product Found</span>
                                        )}
                                    </div>
                                    <div className={`list-grid-wrapper ${grid && 'list-view'}`}>
                                        {Array.isArray(productList) &&
                                            productList.length > 0 &&
                                            productList.map((item, index) => (
                                                <div
                                                    key={index}
                                                    className="product-card h-100 p-8 border border-gray-100 hover-border-main-one-600 rounded-16 position-relative transition-2"
                                                >
                                                    <Link
                                                        to={`/product-details/${encodeURIComponent(item.slug)}`}
                                                        className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                                                    >
                                                        {item?.discountPrice > 0 && item?.discountPrice < item?.price && (
                                                            <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                                                                Sale {Number(item?.discount)?.toFixed(0)?.toLocaleString('en-US')}%
                                                            </span>
                                                        )}

                                                        <img
                                                            src={
                                                                item.photoData && item.photoData.length > 0
                                                                    ? item.photoData[0].url + '?width=225'
                                                                    : '/assets/images/no-image.png'
                                                            }
                                                            alt=""
                                                        />
                                                    </Link>
                                                    <div className="product-card__content w-100">
                                                        <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                                            <Link
                                                                to={`/product-details/${encodeURIComponent(item.slug)}`}
                                                                className="link text-line-2"
                                                                tabIndex={0}
                                                            >
                                                                {item.name || ''}
                                                            </Link>
                                                        </h6>
                                                        <div className="product-card__price my-10 d-flex flex-align gap-4">
                                                            {item?.discountPrice > 0 && item?.discountPrice < item?.price && (
                                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                                                                    {/* {Number(item?.price)
                                                                            ?.toFixed(2)
                                                                            ?.toLocaleString("en-US")} */}
                                                                    {formatCurrency(item?.price)}{' '}
                                                                </span>
                                                            )}
                                                            <span className="text-heading text-md fw-semibold d-flex flex-grow-1">
                                                                {/* {Number(
                                                                    item?.discountPrice > 0 &&
                                                                        item?.discountPrice < item?.price
                                                                        ? item?.discountPrice
                                                                        : item?.price
                                                                )
                                                                    ?.toFixed(2)
                                                                    ?.toLocaleString("en-US")}{" "} */}
                                                                {generateThousandSeparator(
                                                                    formatCurrency(
                                                                        item?.discountPrice > 0 && item?.discountPrice < item?.price
                                                                            ? item?.discountPrice
                                                                            : item?.price
                                                                    ).toString()
                                                                )}{' '}
                                                                <span className="text-gray-500 fw-normal">/Qty</span>{' '}
                                                            </span>
                                                            <span className="text-gray-500 fw-normal d-flex flex-align gap-4">
                                                                <Eye size={16} /> {item?.viewCount}
                                                            </span>{' '}
                                                        </div>
                                                        <Link
                                                            to={`/product-details/${encodeURIComponent(item.slug)}`}
                                                            className="product-card__cart btn bg-main-one-50 text-heading hover-bg-main-one-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                                                            tabIndex={0}
                                                        >
                                                            View Detail
                                                        </Link>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                    <ul className="pagination flex-center flex-wrap gap-16">
                                        {productListTotal > 20 && !isFirstPage && (
                                            <li className="page-item">
                                                <Link
                                                    className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                                    to="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setPage(page > 0 ? page - 1 : 0);
                                                    }}
                                                >
                                                    <i className="ph-bold ph-arrow-left" />
                                                </Link>
                                            </li>
                                        )}
                                        {Array.from({ length: Math.ceil(productListTotal / 20) }, (_, i) => (
                                            <li className={`page-item ${page === i ? 'active' : ''}`} key={i}>
                                                <Link
                                                    className={`page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100 `}
                                                    to="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setPage(i);
                                                    }}
                                                >
                                                    {String(i + 1).padStart(2, '0')}
                                                </Link>
                                            </li>
                                        ))}

                                        {productListTotal > 20 && !isLastPage && (
                                            <li className="page-item">
                                                <Link
                                                    className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                                    to="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setPage(page + 1);
                                                    }}
                                                >
                                                    <i className="ph-bold ph-arrow-right" />
                                                </Link>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SellerStoreProductsHome;
